
import { defineComponent } from "vue";
import  ProfessionalList  from "./ProfessionalList.vue"

export default defineComponent({
    name: "ProfessionalRoute",
    components: { 
        ProfessionalList
    }
});
